import React from "react";
import createIcon from "../createIcon";

export const ErrorRequiredIcon = createIcon({
  path: (
    <path
      d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM20 22C18.9 22 18 21.1 18 20V12C18 10.9 18.9 10 20 10C21.1 10 22 10.9 22 12V20C22 21.1 21.1 22 20 22ZM22 30H18V26H22V30Z"
      fill="#FF9E9E"
    />
  )
});
